import * as React from 'react';
import { UitkMessagingCardMedia } from 'uitk-react-messaging-cards';
import { UitkFigure, UitkFigureAspectRatioType } from 'uitk-react-images';
import { IconMark } from '../../../components/common/icon-mark';
import { ActivityDestinationViewSearch } from '../../../common/__generated__/api';
import Icon = ActivityDestinationViewSearch.Icon;
import Mark = ActivityDestinationViewSearch.Mark;

export interface BannerMediaProps {
  icon?: Icon | null;
  mark?: Mark | null;
}

function freeCancellationBannerMedia(icon: Icon): JSX.Element {
  return (
    <UitkMessagingCardMedia data-testid="freeCancellation-banner-media-icon">
      <UitkFigure ratio={UitkFigureAspectRatioType.R1_1} src={icon.id} />
    </UitkMessagingCardMedia>
  );
}

export const BannerMedia: React.FC<BannerMediaProps> = ({ icon, mark }): JSX.Element | null => {
  const canRenderMedia = icon || mark;
  if (!canRenderMedia) {
    return null;
  }

  if (icon?.description === 'bex') {
    return freeCancellationBannerMedia(icon);
  }
  const renderIconBackground = icon?.withBackground || false;
  const renderedMediaType = mark ? 'mark' : 'icon';

  return (
    <UitkMessagingCardMedia withBackground={renderIconBackground} data-testid={`banner-media-${renderedMediaType}`}>
      <IconMark mark={mark} icon={icon} />
    </UitkMessagingCardMedia>
  );
};
